<div (click)="toggleShowMe()" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
  <h3 class="zero-text p-base-med">{{ 'user-self-service.notifications.headline' | transloco }}</h3>
  <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
</div>

<div class="p-3" [class.d-none]="!showMe">
  <div class="row mb-3">
    <div class="col-12 mb-4" [zeroLoadingIndicator]="ongoingRequest">
      <h4 class="mb-2 zero-text p-small-bold">{{ 'user-self-service.notifications.orders-title' | transloco }}</h4>
      <web-design-system-switch
        [label]="'user-self-service.notifications.orders-text' | transloco"
        [checked]="emailOrdersNotification"
        (checkedChange)="changeEmailNotification('emailnotification_orders', $event)"
      />
    </div>
    <div class="col-12" [zeroLoadingIndicator]="ongoingRequest">
      <h4 class="mb-2 zero-text p-small-bold">{{ 'user-self-service.notifications.money-title' | transloco }}</h4>
      <web-design-system-switch
        [label]="'user-self-service.notifications.money-text' | transloco"
        [checked]="emailMoneyNotification"
        (checkedChange)="changeEmailNotification('emailnotification_money', $event)"
      />
    </div>
  </div>
  <alerting-clever-push-subscriptions />
  @if (resultMessage) {
    <div class="row">
      <p class="zero-text course-green" [class.course-red]="resultError">{{ resultMessage }}</p>
    </div>
  }
</div>
